<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<Toast/>
				<DataTable ref="dt" :value="guides" v-model:selection="selectedRemisionGuide" selectionMode="single" @rowSelect="onRemisionGuideSelected" dataKey="id" :paginator="true" :rows="20" :filters="filters"
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[20,35,50]"
							currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} guías" responsiveLayout="scroll">
					<template #header>
						<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
							<h5 class="m-0">Guías de Remisión</h5>
							<div id="table-header-inputs-container">
								<span id="table-search-input" class="block mt-2 md:mt-0 p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filters['global'].value" placeholder="Search..." />
								</span>
								<span id="table-buttons-container" class="block mt-2 md:mt-0">
									<Button icon="pi pi-plus" class="p-button-rounded p-button-success mr-2" @click="openNew" />
								</span>
							</div>
							
						</div>
					</template>
                    <Column field="sequence" header="Serial" :sortable="true" headerStyle="width:20%; min-width:8rem;">
						<template #body="slotProps">
							{{ (slotProps.data.edoc !== null) ? slotProps.data.edoc.sequence : slotProps.data.id.toString().padStart(9, "0") }}
						</template>
					</Column>
                    <Column field="saleSerialNumber" header="Factura" :sortable="true" headerStyle="width:20%; min-width:10rem;">
						<template #body="slotProps">
							{{ slotProps.data.saleSerialNumber || "-" }}
						</template>
					</Column>
                    <Column field="saleCustomer" header="Cliente" :sortable="true" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							{{ slotProps.data.saleCustomer || "-" }}
						</template>
					</Column>
					<Column field="createdAtFormatted" header="Fecha" :sortable="true" headerStyle="width:20%; min-width:10rem;"></Column>
					<Column field="edocStatus" header="Estado Documento" :sortable="true" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span :class="'status-badge status-' + slotProps.data.edocStateBadgeColor">{{slotProps.data.edocState}}</span>
						</template>
					</Column>
				</DataTable>
                <Dialog v-model:visible="showSalePicker" :style="{width: '550px'}" header="Nueva guía de remisión" :modal="true">
					<div class="mb-3">
						<label for="docType" class="block mb-2 font-semibold">Tipo de documento:</label>
						<Dropdown id="docType" v-model="documentOption" :options="documentOptions" optionLabel="name" placeholder="Selecciona tipo de documento" class="w-full" />
					</div>
					<AutoComplete placeholder="Buscar por cliente..." id="dd" :dropdown="false" :multiple="false" v-model="selectedDocument" @complete="searchDocuments($event)" inputStyle="width: 100%;" style="width: 100%;" :selectOnFocus="true"/>
                    <DataTable :value="this.documents" selectionMode="single" @rowSelect="onDocumentSelected" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
						<Column field="serialNumber" header="Serie" :style="{width: '30%','min-width':'50px'}"></Column>
                        <Column field="customer.name" header="Cliente" :style="{width: '50%','min-width':'100px'}"></Column>
                        <Column field="total" header="Total" :style="{width: '20%','min-width':'100px'}">
                            <template #body="slotProps">
                                ${{ slotProps.data.total.toFixed(2) }}
                            </template>
                        </Column>
                    </DataTable>
					<template #footer>
						<Button label="Continuar sin documento" class="p-button-secondary w-full justify-center" @click="continueWithoutReceipt"/>
					</template>
                </Dialog>
			</div>
		</div>
	</div>

</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import httpRequest from '../../service/httpRequest';
import RemisionGuide from '../../models/remisionGuide';
import Sale from '../../models/sale';
import Proforma from '../../models/proforma';

export default {
	data() {
		return {
			guides: [],
            guide: new RemisionGuide(),

			// Document option
			documentOptions: [
				{name: 'Factura', code: 'sale'},
				{name: 'Proforma', code: 'proforma'},
			],
			documentOption: {name: 'Factura', code: 'sale'},

            selectedRemisionGuide: null,
            documents: [],
            selectedDocument: null,
			filters: {},
            showSalePicker: false,
		}
	},
	created() {
        this.initFilters();
        this.getGuides();
	},
	methods: {
		openNew() {
            this.showSalePicker = true
		},
		confirmDeleteSelected() {
			this.deleteSalesDialog = true;
		},
		initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            }
        },
		onRemisionGuideSelected(event) {
			let sale = event.data;
			this.$router.push('form?id=' + sale.id);
		},
        onDocumentSelected(event) {
			if (this.documentOption.code === "sale") {
				this.$router.push('form?saleId=' + event.data.id);
			} else {
				this.$router.push('form?proformaId=' + event.data.id);
			}
        },
        async searchDocuments(event) {
            let filter = event.query;

			if (this.documentOption.code === "sale") {
				let response = await httpRequest.getSales(filter, null, null, null, null, null, true);
				if (response.status == 200) {
					let sales = response.data;
					this.documents = sales.map(function(data) { return new Sale(data)});
				} else { this.documents = [] }
			} else {
				let response = await httpRequest.getProformas(filter);
				if (response.status == 200) {
					let sales = response.data;
					this.documents = sales.map(function(data) { return new Proforma(data)});
				} else { this.documents = [] }
			}
        },
		async getGuides() {
            let response = await httpRequest.getGuides();
            if (response.status == 200) {
                let guides = response.data;
                this.guides = guides.map(function(data) { return new RemisionGuide(data)});
            }
        },
		continueWithoutReceipt() {
			this.$router.push('form');
		},
	}
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/badges.scss';

@media screen and (max-width: 769px) {
	#table-header-inputs-container {
		display: block;
	}
	#table-search-input {
		margin: 15px 0px !important;
	}
}
@media screen and (min-width: 769px) {
	#table-header-inputs-container {
		display: flex;
	}
	#table-search-input {
		margin: 0px 15px;
	}
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-green {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-red {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-yellow {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-orange {
        background: #ffa177;
        color: #da2727;
    }

	&.status-blue {
        background: #B3E5FC;
        color: #23677B;
    }

	&.status-gray {
        background: #d6d8d9;
        color: #464747;
    }
}
</style>
